import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { MatDialog, MatSnackBar } from '@angular/material';
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { LearnerService } from '../../services/learner.service';
import { UserRoleService } from '../../services/user-role.service';

import { bool } from 'aws-sdk/clients/signer';
@Component({
  selector: 'app-master-rail-l2-form1',
  templateUrl: './master-rail-l2-form1.component.html',
  styleUrls: ['./master-rail-l2-form1.component.scss']
})
export class MasterRailL2Form1Component implements OnInit {

  @Input('jobId') selectedJob;
  @Input('learnerId') selecetdLearner;
  @Input('assesment') assessmentEdit;
  @Input('job') job;


  currentJob;
  currentLearner;
  observationData;
  observationForm: any;
  sign1 = false
  sign2 = false
  sign3 = false
  sign4 = false
  evidenceList = []
  loading = false
  isEdit: boolean = false
  jobData: any;
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;

  constructor(
    public dialog: MatDialog,
    public _learnerService: LearnerService,
    public _snackBar: MatSnackBar,
    public _userRoleService: UserRoleService

  ) { }

  ngOnInit() {
    if (!this.isEdit)
      this.createForm()
  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedJob && changes.selectedJob.currentValue) {
      this.currentJob = changes.selectedJob.currentValue
    }
    if (changes.job && changes.job.currentValue) {
      this.jobData = changes.job.currentValue[0]
      this.getUserRole();
    }



    if (changes.selecetdLearner && changes.selecetdLearner.currentValue) {
      this.currentLearner = changes.selecetdLearner.currentValue
      this.getEvidenceList()
    }


    if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
      this.observationData = changes.assessmentEdit.currentValue

      if (this.observationData && this.observationData.observationForm) {
        if (this.observationData.observationForm && this.observationData.observationForm.sign1 != "") {
          this.sign1 = true
        }
        if (this.observationData.observationForm && this.observationData.observationForm.sign2 != "") {
          this.sign2 = true
        }
        if (this.observationData.observationForm && this.observationData.observationForm.sign3 != "") {
          this.sign3 = true
        }
        if (this.observationData.observationForm && this.observationData.observationForm.sign4 != "") {
          this.sign4 = true
        }
      }


      this.isEdit = true
      this.createForm(this.observationData)
      console.log("Edit Form DATA.........", this.observationData);

    }
    else {
      this.createForm()
    }

    console.log("what is the main changes to be update", changes);


  }

  getUserRole() {
    console.log("this......................", this.jobData);

    let getRole = this._userRoleService.getUserRole(this.jobData.instructors, 'job');
    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isLearner) this.isLearner = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true
  }

  // FORM CONTROLS


  createForm(details?) {


    this.observationForm = new FormGroup({
      sign1: new FormControl((details && details.observationForm) ? details.observationForm.sign1 : ''),
      date1: new FormControl((details && details.observationForm) ? details.observationForm.date1 : ''),
      sign2: new FormControl((details && details.observationForm) ? details.observationForm.sign2 : ''),
      date2: new FormControl((details && details.observationForm) ? details.observationForm.date2 : ''),
      sign3: new FormControl((details && details.observationForm) ? details.observationForm.sign3 : ''),
      date3: new FormControl((details && details.observationForm) ? details.observationForm.date3 : ''),
      sign4: new FormControl((details && details.observationForm) ? details.observationForm.sign4 : ''),
      date4: new FormControl((details && details.observationForm) ? details.observationForm.date4 : ''),
      ev1: new FormControl((details && details.observationForm) ? details.observationForm.ev1 : ''),
      ev2: new FormControl((details && details.observationForm) ? details.observationForm.ev2 : ''),
      ev3: new FormControl((details && details.observationForm) ? details.observationForm.ev3 : ''),
      ev4: new FormControl((details && details.observationForm) ? details.observationForm.ev4 : ''),
      ev5: new FormControl((details && details.observationForm) ? details.observationForm.ev5 : ''),
      ev6: new FormControl((details && details.observationForm) ? details.observationForm.ev6 : ''),
      ev7: new FormControl((details && details.observationForm) ? details.observationForm.ev7 : ''),
      ev8: new FormControl((details && details.observationForm) ? details.observationForm.ev8 : ''),
      ev9: new FormControl((details && details.observationForm) ? details.observationForm.ev9 : ''),
      ev10: new FormControl((details && details.observationForm) ? details.observationForm.ev10 : ''),
      ev11: new FormControl((details && details.observationForm) ? details.observationForm.ev11 : ''),
      ev12: new FormControl((details && details.observationForm) ? details.observationForm.ev12 : ''),
      ev13: new FormControl((details && details.observationForm) ? details.observationForm.ev13 : ''),
      ev14: new FormControl((details && details.observationForm) ? details.observationForm.ev14 : ''),
      ev15: new FormControl((details && details.observationForm) ? details.observationForm.ev15 : ''),
      ev16: new FormControl((details && details.observationForm) ? details.observationForm.ev16 : ''),
      ev17: new FormControl((details && details.observationForm) ? details.observationForm.ev17 : ''),
      ev18: new FormControl((details && details.observationForm) ? details.observationForm.ev18 : ''),
      ev19: new FormControl((details && details.observationForm) ? details.observationForm.ev19 : ''),
      ev20: new FormControl((details && details.observationForm) ? details.observationForm.ev20 : ''),
      ev21: new FormControl((details && details.observationForm) ? details.observationForm.ev21 : ''),
      ev22: new FormControl((details && details.observationForm) ? details.observationForm.ev22 : ''),
      ev23: new FormControl((details && details.observationForm) ? details.observationForm.ev23 : ''),
      ev24: new FormControl((details && details.observationForm) ? details.observationForm.ev24 : ''),
      ev25: new FormControl((details && details.observationForm) ? details.observationForm.ev25 : ''),
      ev26: new FormControl((details && details.observationForm) ? details.observationForm.ev26 : ''),
      ev27: new FormControl((details && details.observationForm) ? details.observationForm.ev27 : ''),
      ev28: new FormControl((details && details.observationForm) ? details.observationForm.ev28 : ''),
      ev29: new FormControl((details && details.observationForm) ? details.observationForm.ev29 : ''),
      ev30: new FormControl((details && details.observationForm) ? details.observationForm.ev30 : ''),
      ev31: new FormControl((details && details.observationForm) ? details.observationForm.ev31 : ''),
      ev32: new FormControl((details && details.observationForm) ? details.observationForm.ev32 : ''),
      ev33: new FormControl((details && details.observationForm) ? details.observationForm.ev33 : ''),
      ev34: new FormControl((details && details.observationForm) ? details.observationForm.ev34 : ''),
      ev35: new FormControl((details && details.observationForm) ? details.observationForm.ev35 : ''),
      ev36: new FormControl((details && details.observationForm) ? details.observationForm.ev36 : ''),
      ev37: new FormControl((details && details.observationForm) ? details.observationForm.ev37 : ''),
      ev38: new FormControl((details && details.observationForm) ? details.observationForm.ev38 : ''),
      ev39: new FormControl((details && details.observationForm) ? details.observationForm.ev39 : ''),
      ev40: new FormControl((details && details.observationForm) ? details.observationForm.ev40 : ''),
      ev41: new FormControl((details && details.observationForm) ? details.observationForm.ev41 : ''),
      ev42: new FormControl((details && details.observationForm) ? details.observationForm.ev42 : ''),
      ev43: new FormControl((details && details.observationForm) ? details.observationForm.ev43 : ''),
      ev44: new FormControl((details && details.observationForm) ? details.observationForm.ev44 : ''),
      ev45: new FormControl((details && details.observationForm) ? details.observationForm.ev45 : ''),
      ev46: new FormControl((details && details.observationForm) ? details.observationForm.ev46 : ''),
      ev47: new FormControl((details && details.observationForm) ? details.observationForm.ev47 : ''),
      ev48: new FormControl((details && details.observationForm) ? details.observationForm.ev48 : ''),
      ev49: new FormControl((details && details.observationForm) ? details.observationForm.ev49 : ''),
      ev50: new FormControl((details && details.observationForm) ? details.observationForm.ev50 : ''),
      ev51: new FormControl((details && details.observationForm) ? details.observationForm.ev51 : ''),
      ev52: new FormControl((details && details.observationForm) ? details.observationForm.ev52 : ''),
      ev53: new FormControl((details && details.observationForm) ? details.observationForm.ev53 : ''),
      ev54: new FormControl((details && details.observationForm) ? details.observationForm.ev54 : ''),
      ev55: new FormControl((details && details.observationForm) ? details.observationForm.ev55 : ''),
      ev56: new FormControl((details && details.observationForm) ? details.observationForm.ev56 : ''),
      ev57: new FormControl((details && details.observationForm) ? details.observationForm.ev57 : ''),
      ev58: new FormControl((details && details.observationForm) ? details.observationForm.ev58 : ''),
      ev59: new FormControl((details && details.observationForm) ? details.observationForm.ev59 : ''),
      ev60: new FormControl((details && details.observationForm) ? details.observationForm.ev60 : ''),
      ev61: new FormControl((details && details.observationForm) ? details.observationForm.ev61 : ''),
      ev62: new FormControl((details && details.observationForm) ? details.observationForm.ev62 : ''),
      ev63: new FormControl((details && details.observationForm) ? details.observationForm.ev63 : ''),
      ev64: new FormControl((details && details.observationForm) ? details.observationForm.ev64 : ''),
      ev65: new FormControl((details && details.observationForm) ? details.observationForm.ev65 : ''),
      ev66: new FormControl((details && details.observationForm) ? details.observationForm.ev66 : ''),
      ev67: new FormControl((details && details.observationForm) ? details.observationForm.ev67 : ''),
      ev68: new FormControl((details && details.observationForm) ? details.observationForm.ev68 : ''),
      ev69: new FormControl((details && details.observationForm) ? details.observationForm.ev69 : ''),
      ev70: new FormControl((details && details.observationForm) ? details.observationForm.ev70 : ''),
      ev71: new FormControl((details && details.observationForm) ? details.observationForm.ev71 : ''),
      ev72: new FormControl((details && details.observationForm) ? details.observationForm.ev72 : ''),
      ev73: new FormControl((details && details.observationForm) ? details.observationForm.ev73 : ''),
      ev74: new FormControl((details && details.observationForm) ? details.observationForm.ev74 : ''),
      ev75: new FormControl((details && details.observationForm) ? details.observationForm.ev75 : ''),
      ev76: new FormControl((details && details.observationForm) ? details.observationForm.ev76 : ''),
      ev77: new FormControl((details && details.observationForm) ? details.observationForm.ev77 : ''),
      ev78: new FormControl((details && details.observationForm) ? details.observationForm.ev78 : ''),
      ev79: new FormControl((details && details.observationForm) ? details.observationForm.ev79 : ''),
      ev80: new FormControl((details && details.observationForm) ? details.observationForm.ev80 : ''),
      ev81: new FormControl((details && details.observationForm) ? details.observationForm.e81 : ''),
      ev82: new FormControl((details && details.observationForm) ? details.observationForm.ev82 : ''),
      ev83: new FormControl((details && details.observationForm) ? details.observationForm.ev83 : ''),
      ev84: new FormControl((details && details.observationForm) ? details.observationForm.ev84 : ''),
      ev85: new FormControl((details && details.observationForm) ? details.observationForm.ev85 : ''),
      ev86: new FormControl((details && details.observationForm) ? details.observationForm.ev86 : ''),
      ev87: new FormControl((details && details.observationForm) ? details.observationForm.ev87 : ''),
      ev88: new FormControl((details && details.observationForm) ? details.observationForm.ev88 : ''),
      ev89: new FormControl((details && details.observationForm) ? details.observationForm.ev89 : ''),
      ev90: new FormControl((details && details.observationForm) ? details.observationForm.ev90 : ''),
    });

  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'observationForm')
      this.observationForm.get(formControl).setValue(value);
  }


  // UTILITY

  addSign(control) {
    if (this.isIQA || this.isLearner) return
    else {
      this.openDialog(SignaturePadComponent).subscribe(data => {
        console.log("data of sign", data);
        if (data == undefined) return

        if (control == 'sign1') {
          this.sign1 = true
          this.observationForm.patchValue({
            sign1: data
          })
        }


        if (control == 'sign2') {
          this.sign2 = true
          this.observationForm.patchValue({
            sign2: data
          })
        }


        if (control == 'sign3') {
          this.sign3 = true
          this.observationForm.patchValue({
            sign3: data
          })
        }



        if (control == 'sign4') {
          this.sign4 = true
          this.observationForm.patchValue({
            sign4: data
          })
        }


      })
    }


  }


  compareObjects(o1: any, o2: any): boolean {
    // console.log("compareObjects called")
    return o1._id === o2._id;
  }


  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }



  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }







  // API CALL


  submitObservation() {
    console.log("form data", this.observationForm.value);

    let data = {
      learnerId: this.currentLearner,
      jobId: this.currentJob,
      version: true,
      details: {
        observationForm: this.observationForm.value
      }
    }
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("policy not accepted", err)
    })
  }




  getEvidenceList() {
    this._learnerService.getEvidenceByLearner(this.currentLearner, this.currentJob).subscribe(res => {
      console.log("RES of evidence in evidence tab", res);
      if (res && res.length) {
        // this.evidenceList = res
        // let evList=res
        let evArrayOriginal = []
        for (let i = 0; i < res.length; i++) {
          let obj = {
            _id: res[i]._id,
            evidenceNo: res[i].evidenceNo
          }

          evArrayOriginal.push(obj)
        }
        this.evidenceList = evArrayOriginal;

        console.log("RES of evidence in evidence tabddd", this.evidenceList);
        if (this.observationData && this.observationData.observationForm) {
          this.createForm(this.observationData)
        }

      }
    })
    // }
  }

}
